// extracted by mini-css-extract-plugin
export default {"Dot":"Dot_Dot__UWRJj","Dot--positive":"Dot_Dot--positive__dNBG2","Dot--negative":"Dot_Dot--negative__ByUu4"};